module.exports = __webpack_public_path__ + "img/task.a40b1291.png";